// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DzuJK","box":"styles_box__8Kqtb","title":"styles_title__tQEZL","icon":"styles_icon__MThXo","list":"styles_list__ACXV4","card":"styles_card__AOqW4"};